import React, { useState, useReducer, useEffect, useRef } from 'react';
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import breakimage from '../../../../images/auth/Front-break.jpg';
import $ from 'jquery';
import { Row, Col, Tab, Nav, Badge } from "react-bootstrap";
import LightGallery from 'lightgallery/react';
// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import vehicle from '../../../../images/vehicle/default_vehicle.png';
import documents from '../../../../images/doc.png';
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import axios from 'axios';
import { useLocation } from 'react-router-dom';

const ViewVehicle = () => {

    const location = useLocation();
    const { ID } = location.state || {};
        
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const imgBaseUrl = process.env.REACT_APP_IMG_BASE_URL;
    const [data, setData] = useState([]);
    const [hasFetched, setHasFetched] = useState(false);
    const [attachments, setattachments] = useState([]);

    const [maintenanceData, setmaintenanceData] = useState([]);

    const fetchData = (id) => {
        axios.get(`${baseURL}/manage_maintenance/vehicle/${id}`)
            .then(response => {
                setmaintenanceData(response.data.data);
                setHasFetched(true);
            })
            .catch(error => {
                console.log('There was an error fetching the data!', error);
                setHasFetched(true);
            });
    };

    // fetch data
    useEffect(() => {
        if (ID) {
            axios.get(`${baseURL}/manage_vehicle/${ID}`)
                .then(response => {
                    setData(response.data.data);
                    setattachments(response.data.data.attachmentsrelation);
                })
                .catch(error => {
                    console.log('There was an error fetching the data!', error);
                });
            
            fetchData(ID);
        }
    }, [ID]);

    const [doctypeopt, setdoctypopt] = useState([]);
    useEffect(() => {
        const fetchLeadSource = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/documenttype`);
                const formattedsource = response.data.data.map(item => ({
                    value: item.sno,
                    label: item.documenttype_name,
                }));
                setdoctypopt(formattedsource);
            } catch (error) {
                console.log('Error fetching data:', error);
            }
        };

        fetchLeadSource();
    }, []);

    const [selectedDoctype, setSelectedDoctype] = useState([]);
    useEffect(() => {
        if (data.document_type) {
            let valu = data.document_type;
            const selectedIds = valu.split(',').map(id => parseInt(id));
            // console.log(selectedIds);
            const preselected = doctypeopt.filter(option => selectedIds.includes(option.value));
            // console.log(preselected);
            setSelectedDoctype(preselected);
        }
    }, [data]);

    const vehicle_purpose = [
        { value: 1, label: "Delivery" },
        { value: 2, label: "Office Work" },
        { value: 3, label: "Others" }
    ];

    const [selectedPorpose, setSelectedPorpose] = useState([]);
    useEffect(() => {
        if (data.vehicle_purpose) {
            let valu = data.vehicle_purpose;
            const selectedIds = valu.split(',').map(id => parseInt(id));
            // console.log(selectedIds);
            const preselected = vehicle_purpose.filter(option => selectedIds.includes(option.value));
            // console.log(preselected);
            setSelectedPorpose(preselected);
        }
    }, [data]);


    const [servicetypeoption, setServicetype] = useState([]);
    useEffect(() => {
        const fetchdata = async () => {
            try {
            const response = await axios.get(`${baseURL}/dropdown/servicetype`);
            const formatted = response.data.data.map(item => ({
                value: item.sno,
                label: item.servicetype_name,
            }));
            setServicetype(formatted);
            } catch (error) {
            console.log('Error fetching data', error);
            }
        };

        fetchdata();
    }, []);

    

    const getdervicetype = (values) => {
        const selectedIds = values.split(',').map(id => parseInt(id.trim())); // trim to remove whitespace
        const matchedOptions = servicetypeoption.filter(option => selectedIds.includes(option.value));
        const labels = matchedOptions.map(option => option.label);
        return labels.join(', ');
    };





    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    const [key, setKey] = useState('basic_info');
    const tableRef = useRef(null);
    const [isVisible, setIsVisible] = useState({
        weekly: true,
        monthly: true,
        yearly: false,
    });
    const toggleDiv = (section) => {
        setIsVisible((prev) => ({
            ...prev,
            [section]: !prev[section], // Toggle the visibility of the clicked section
        }));
    };

    const orderBlog = [
        { id: 1, image: breakimage, number: 1 },
        // { id: 2, image: mealimage, number: 1 },
        // { id: 3, image: dinnerimage, number: 1 },
    ];

    const reducer = (previousState, updatedState) => ({
        ...previousState,
        ...updatedState,
    });
    const [state, setState] = useReducer(reducer, { orderBlog: orderBlog });
    const handleCountAdd = (e) => {
        let temp = state.orderBlog.map((data) => {
            if (e === data.id) {
                return { ...data, number: data.number + 1 };
            }
            return data;
        });
        setState({ orderBlog: temp });
    }
    const handleCountMinus = (e) => {
        let temp = state.orderBlog.map((data) => {
            if (e === data.id) {
                return { ...data, number: data.number > 0 ? data.number - 1 : data.number };
            }
            return data;
        });
        setState({ orderBlog: temp });
    }

    useEffect(() => {
        if (hasFetched) {
            const tables = document.querySelectorAll('.subscription_table');
            tables.forEach((table) => {
                if (!$.fn.dataTable.isDataTable(table)) {
                    $(table).DataTable({
                        "responsive": true,
                        "ordering": false,
                        pageLength: 25,
                        "language": {
                            "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                        },
                        "dom":
                            "<'row'" +
                            "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                            "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                            ">" +
                            "<'table-responsive'tr>" +
                            "<'row'" +
                            "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                            "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                            ">"
                    });
                }
            });
        }
    }, [hasFetched]);

    const [file, setFile] = React.useState(null)

    const fuel_type = [
        { value: null, label: "All" },
        { value: 1, label: "Petrol" },
        { value: 2, label: "Diesel" },
        { value: 3, label: "Electric" },
    ];

    const formatDate = (date) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const isImageFile = (filename) => {
        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
        const ext = filename.split('.').pop().toLowerCase();
        return imageExtensions.includes(ext);
    };

    const handleDownload = (fileUrl, fileName) => {
        const link = document.createElement('a');
        link.href = fileUrl;
        // link.setAttribute('download', fileName);
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    

    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 flex-wrap">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>View Vehicle</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Maintenance Management</li>
                        <li className="breadcrumb-item"><i className="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active"><Link to='/manage-vehicles'>Manage Vehicle</Link></li>
                    </ol>
                </div>
                <div className='mb-2'>
                    <div className='fs-5 font-w500 text-black'>{data.vehicle_number}
                    </div>
                    <div className='d-block'>
                        <label className='fs-7 font-w500 text-black'>{data.category_name}
                        </label>
                    </div>
                </div>
            </div>
            <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="basic_info">
                                    <i className="fa-regular fa-user me-2" />
                                    <label className="ms-2 fs-6">
                                        Basic Information
                                    </label>

                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="maintance_his">
                                    <i className="fa-solid fa-calendar-days me-2" />
                                    <label className="ms-2 fs-6">
                                        Maintenance  History
                                    </label>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Tab.Content className="pt-4">
                            <Tab.Pane eventKey="basic_info">
                                <div className="row">
                                    <div className='col-lg-5'>
                                        <div className='card px-3'>
                                            <div className="mt-4 d-flex align-items-start justify-content-center mb-3">
                                                <LightGallery
                                                    onInit={onInit}
                                                    speed={500}
                                                    plugins={[lgThumbnail, lgZoom]}
                                                >
                                                    <div data-src={(imgBaseUrl && data.vehicle_image) ? imgBaseUrl + '/' + data.vehicle_image : vehicle} className='rounded px-1 py-0'>
                                                        <img src={(imgBaseUrl && data.vehicle_image) ? imgBaseUrl + '/' + data.vehicle_image : vehicle} alt={data.vehicle_brand + ' ' + data.vehicle_model} className='cursor-pointer w-150px h-150px' />
                                                    </div>
                                                </LightGallery>
                                            </div>
                                            <div className='row'>
                                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                    <label className='text-gray-800 font-w500 fs-7'>Vehicle Category</label>
                                                    <label className='text-black fs-6 font-w500'>{data.category_name}</label>
                                                </div>
                                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                    <label className='text-gray-800 font-w500 fs-7'>Vehicle Brand</label>
                                                    <label className='text-black fs-6 font-w500'>{data.vehicle_brand}</label>
                                                </div>
                                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                    <label className='text-gray-800 font-w500 fs-7'>Vehicle Number</label>
                                                    <label className='text-red fs-6 font-w500'>{data.vehicle_number}</label>
                                                </div>
                                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                    <label className='text-gray-800 font-w500 fs-7'>Registration Date</label>
                                                    <label className='text-black fs-6 font-w500'>{formatDate(data.registration_date)}</label>
                                                </div>
                                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                    <label className='text-gray-800 font-w500 fs-7'>Upcoming Maintenance Date</label>
                                                    <div>
                                                        <Badge bg="info" className='text-white fs-7 py-0 px-1'>
                                                            <span>{formatDate(data.upcoming_maintenance_date)}</span>
                                                        </Badge>
                                                    </div>
                                                    {/* <label className='text-black fs-6 font-w500'></label> */}
                                                </div>
                                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                    <label className='text-gray-800 font-w500 fs-7'>Manufactured Date</label>
                                                    <label className='text-black fs-6 font-w500'>{data.manufactured_date ? formatDate(data.manufactured_date) : '-'}</label>
                                                </div>

                                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                    <label className='text-gray-800 font-w500 fs-7'>Vehicle Color</label>
                                                    <label className='text-black fs-6 font-w500'>{data.vehicle_color !== '' && data.vehicle_color !== 'null' ? data.vehicle_color : '-'}</label>
                                                </div>
                                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                    <label className='text-gray-800 font-w500 fs-7'>Vehicle Model</label>
                                                    <label className='text-black fs-6 font-w500'>{data.vehicle_model}</label>
                                                </div>


                                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                    <label className='text-gray-800 font-w500 fs-7'>Vehicle Purpose</label>
                                                    <label className='text-black fs-6 font-w500'>{selectedPorpose.map(option => option.label).join(', ')}</label>
                                                </div>
                                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                    <label className='text-gray-800 font-w500 fs-7'>Fuel Type</label>
                                                    <label className='text-black fs-6 font-w500'>{fuel_type.find(f => f.value === data.fuel_type)?.label}</label>
                                                </div>
                                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                    <label className='text-gray-800 font-w500 fs-7'>Fuel Capacity</label>
                                                    <label className='text-black fs-6 font-w500'>{data.fuel_capacity !== '' && data.fuel_capacity != 'null' ? data.fuel_capacity : '-'}</label>
                                                </div>
                                                <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                    <label className='text-gray-800 font-w500 fs-7'>Average Mileage</label>
                                                    <label className='text-black fs-6 font-w500'>{data.average_mileage}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-lg-7'>
                                        <div className='card p-4'>
                                            <label className='text-red fs-4 fw-bold mb-3'>Documents Information</label>
                                            <div className='row'>
                                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                    <label className='text-gray-800 font-w500 fs-7'>Insurance Company</label>
                                                    <label className='text-black fs-6 font-w500'>{data.insurance_company ? data.insurance_company : '-'}</label>
                                                </div>
                                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                    <label className='text-gray-800 font-w500 fs-7'>Insurance Policy Number</label>
                                                    <label className='text-black fs-6 font-w500'>{data.insurance_policy_number ? data.insurance_policy_number : '-'}</label>
                                                </div>
                                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                    <label className='text-gray-800 font-w500 fs-7'>Insurance Start Date</label>
                                                    <label className='text-black fs-6 font-w500'>{data.insurance_start_date ? formatDate(data.insurance_start_date) : '-'}</label>
                                                </div>
                                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                    <label className='text-gray-800 font-w500 fs-7'>Insurance End Date</label>
                                                    <label className='text-black fs-6 font-w500'>{data.insurance_end_date ? formatDate(data.insurance_end_date) : '-'}</label>
                                                </div>
                                                <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                    <label className='text-gray-800 font-w500 fs-7'>Document Type</label>
                                                    <label className='text-black fs-6 font-w500'>{selectedDoctype.length > 0 ? selectedDoctype.map(option => option.label).join(', ') : '-'}</label>
                                                </div>
                                                <div className='col-lg-12 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                    <label className='text-gray-800 font-w600 fs-6'>Description</label>
                                                    <label className='text-black fs-7'>&emsp;&emsp;{data.description ? data.description : '-'}</label>
                                                </div>
                                                <label className='text-gray-800 font-w600 fs-6 mb-2 mt-2'>Attachment</label>
                                                <div className='col-lg-12 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                                    {attachments.length > 0 ? (
                                                        <div className="avatar-upload d-flex flex-column align-items-start">
                                                            <div className="change position-relative">
                                                                <div className="d-flex flex-wrap align-items-center gap-2 px-2 py-2">

                                                                    {/* <div className="preview-image-container position-relative">
                                                                        <img
                                                                            download={documents}
                                                                            id="saveImageFile"
                                                                            src={documents}
                                                                            alt="attachment"
                                                                            className="w-100px h-110px"
                                                                        />
                                                                        <a
                                                                            href={documents}
                                                                            download={documents}
                                                                            className="download-icon position-absolute top-50 start-50 translate-middle p-2"
                                                                            style={{
                                                                                backgroundColor: 'rgb(180 228 126)',
                                                                                borderRadius: '50%',
                                                                            }}
                                                                        >
                                                                            <i className="fa-solid fa-download text-black fs-6"></i>
                                                                        </a>
                                                                    </div> */}

                                                                    {attachments.map((doc, index) => {
                                                                        const fileUrl = imgBaseUrl + '/' + doc.file_path;
                                                                        const isImage = isImageFile(doc.file_name);
                                                                        return (
                                                                            <div key={index} className="preview-image-container position-relative">
                                                                                <img
                                                                                    id="saveImageFile"
                                                                                    src={isImage ? fileUrl : documents}
                                                                                    alt="attachment"
                                                                                    className="w-100px h-110px object-fit-cover"
                                                                                    download={isImage ? fileUrl : documents}
                                                                                />
                                                                                <a
                                                                                    href={isImage ? fileUrl : documents}
                                                                                    download={isImage ? fileUrl : documents}
                                                                                    // onClick={() => handleDownload(fileUrl, doc.file_name)}
                                                                                    className="download-icon position-absolute top-50 start-50 translate-middle p-2"
                                                                                    style={{
                                                                                        backgroundColor: 'rgb(180 228 126)',
                                                                                        borderRadius: '50%',
                                                                                    }}
                                                                                >
                                                                                    <i className="fa-solid fa-download text-black fs-6"></i>
                                                                                </a>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                    
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ):(
                                                        <>
                                                            <label className='text-black fs-6 font-w500'>No Attachments</label>
                                                        </>
                                                    )}
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Tab.Pane>

                            <Tab.Pane eventKey="maintance_his">
                                <Row>
                                    <Col xl={12}>
                                        <div className="table-container">
                                            <table className="subscription_table table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                                <thead>
                                                    <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                        <th className='min-w-80px text-start'>Service Date</th>
                                                        <th className='min-w-100px'>Service Type</th>
                                                        <th className='min-w-100px text-center'>Service Notes</th>
                                                        <th className='min-w-100px text-center'>Description</th>
                                                        <th className='min-w-80px'>Service Amount </th>
                                                        <th className='min-w-80px'>Upcoming Service</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-gray-600 fw-semibold fs-7">
                                                    {maintenanceData.map((data, index) => (
                                                        <tr key={index}>
                                                            <td className='text-start'>
                                                                <label className='text-black font-w400 fs-7'>{formatDate(data.created_at)}</label>
                                                            </td>
                                                            <td>
                                                                <label className='text-black font-w400 fs-7'>{getdervicetype(data.service_type)}</label>
                                                            </td>
                                                            <td>
                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{data.service_notes}</span></Tooltip>} >
                                                                    <div className='text-truncate mw-200px text-black font-w400 fs-7'>{data.service_notes}</div>
                                                                </OverlayTrigger>
                                                            </td>
                                                            <td>
                                                                {data.description ? (
                                                                <OverlayTrigger trigger={['hover', 'focus']} placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>{data.description ? data.description : '-'}</span></Tooltip>} >
                                                                    <div className='text-truncate mw-200px text-black font-w400 fs-7'>{data.description ? data.description : '-'}</div>
                                                                </OverlayTrigger>
                                                                ): (
                                                                    <div className='text-truncate mw-200px text-black font-w400 fs-7'>{data.description ? data.description : '-'}</div>
                                                                )}
                                                            </td>
                                                            <td align='right'>
                                                                <Badge bg="danger" className='text-white fs-7 py-0 px-1'>
                                                                    <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                                    <span>{data.service_amount}</span>
                                                                </Badge>
                                                            </td>
                                                            <td>
                                                                <label className='text-black font-w400 fs-7'>{formatDate(data.upcomming_maintanence_date)}</label>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Col>
                                </Row>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Col>
        </>
    )


}
export default ViewVehicle;